<ng-container *ngIf="view$ | async as view">
  <td *ngIf="tableMeta.selectionMode !== '' && !readOnly" class="table-data-no-overflow table-col-checkbox">
    <span class="ui-column-title-custom">Označi: </span>
    <span class="ui-cell-content">
      <p-tableCheckbox *ngIf="tableMeta.selectionMode === 'multiple'" [value]="item"></p-tableCheckbox>
    </span>
  </td>

  <td *ngFor="let column of tableMeta.columns; let columnIndex = index"
      (click)="toggleExpandedRow(tableData, item)"
      [ngClass]="DISPLAY_TEXT_OVERFLOW
        ? isRowExpanded(tableData, item)
          ? 'table-data-expanded'
          : 'table-data-overflow'
        : 'table-data-no-overflow'"
  >
    <!-- TODO refaktorirati ove ifove u zasebnu komponentu za klikabilne stupce -->
    <ng-container *ngIf="column.name === 'en~agent~naziv' ">
      <ng-container *ngIf="isOpenItemColumn('sv~autor~identifikator', view)"></ng-container>
      <ng-container *ngIf="$any(item)['sv~autor~identifikator']">
        <a class="ui-cell-content" href="#" (click)="openItem($event); $event.stopPropagation()">
          <b>{{ $any(tableItem)[column.name] }}</b>
        </a>
      </ng-container>
      <ng-container *ngIf="!$any(item)['sv~autor~identifikator']">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <div class="property-input" [ngClass]="'attr-' + inputs[columnIndex].attributeMetadata.name">
              <ntap-dynamic [compId]="inputs[columnIndex].componentId" [inputParam]="inputs[columnIndex]"></ntap-dynamic>
            </div>
          </ng-template>
          <ng-template pTemplate="output">
            <pre class="ui-cell-content">{{ $any(tableItem)[column.name] | displayFormat : column }}</pre>
          </ng-template>
        </p-cellEditor>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="column.name === 'seup~subjekt~naziv' ">
          <pre class="ui-cell-content">{{ $any(tableItem)[column.name] | displayFormat : column }}</pre>
    </ng-container>


    <ng-container *ngIf="column.name === 'rel~jedinica_gradiva_veze~naziv'">
      <ng-container *ngIf="isOpenItemColumn('rel~jedinica_gradiva_veze~povezana_jedinica_gradiva_id', view)"></ng-container>
      <ng-container *ngIf="$any(item)['rel~jedinica_gradiva_veze~povezana_jedinica_gradiva_id']">
        <a class="ui-cell-content" href="#" (click)="openItem($event); $event.stopPropagation()">
          <b>{{ $any(tableItem)[column.name] }}</b>
        </a>
      </ng-container>
      <ng-container *ngIf="!$any(item)['rel~jedinica_gradiva_veze~povezana_jedinica_gradiva_id']">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <div class="property-input" [ngClass]="'attr-' + inputs[columnIndex].attributeMetadata.name">
              <ntap-dynamic [compId]="inputs[columnIndex].componentId" [inputParam]="inputs[columnIndex]"></ntap-dynamic>
            </div>
          </ng-template>
          <ng-template pTemplate="output">
            <span class="ui-cell-content">{{ $any(tableItem)[column.name] | displayFormat : column }}</span>
          </ng-template>
        </p-cellEditor>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="column.name === 'en~mjesto~glavni_naziv'">
      <ng-container *ngIf="isOpenItemColumn('sv~mjesto~mjesto_id', view)"></ng-container>
      <ng-container *ngIf="$any(item)['sv~mjesto~mjesto_id']">
        <a class="ui-cell-content" href="#" (click)="openItem($event); $event.stopPropagation()">
          <b>{{ $any(tableItem)[column.name] }}</b>
        </a>
      </ng-container>
      <ng-container *ngIf="!$any(item)['sv~mjesto~mjesto_id']">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <div class="property-input" [ngClass]="'attr-' + inputs[columnIndex].attributeMetadata.name">
              <ntap-dynamic [compId]="inputs[columnIndex].componentId" [inputParam]="inputs[columnIndex]"></ntap-dynamic>
            </div>
          </ng-template>
          <ng-template pTemplate="output">
            <pre class="ui-cell-content">{{ $any(tableItem)[column.name] | displayFormat : column }}</pre>
          </ng-template>
        </p-cellEditor>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="column.name === 'rel~jedinica_gradiva_veze~url'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          <div class="property-input" [ngClass]="'attr-' + inputs[columnIndex].attributeMetadata.name">
            <ntap-dynamic [compId]="inputs[columnIndex].componentId" [inputParam]="inputs[columnIndex]"></ntap-dynamic>
          </div>
        </ng-template>
        <ng-template pTemplate="output">
          <div *ngIf="column.controlType === 14; else plainTextFormat"></div>
          <ng-template #plainTextFormat>
            <a 
            class="ui-cell-content" 
            [href]="$any(tableItem)[column.name]"
            target="_blank"
            rel="noopener"
            >
            {{ $any(tableItem)[column.name] | displayFormat : column }}
          </a>
          </ng-template>
        </ng-template>
      </p-cellEditor>
    </ng-container>

      <ng-container *ngIf="inputs">
        <p-cellEditor>
          <ng-container *ngIf="!isColumnExcluded(column.name)">
            <ng-template pTemplate="input">
                <div class="property-input" [ngClass]="'attr-' + inputs[columnIndex].attributeMetadata.name">
                  <ntap-dynamic [compId]="inputs[columnIndex].componentId" [inputParam]="inputs[columnIndex]"></ntap-dynamic>
                </div>
              </ng-template>
            <ng-template pTemplate="output">
              <div *ngIf="column.controlType === 14; else plainTextFormat"></div>
              <ng-template #plainTextFormat>
                <ng-container [ngSwitch]="column.name">
                  <pre *ngSwitchCase="'sv~autor~identifikator'" class="ui-cell-content">{{ $any(tableItem)['en~agent~naziv'] | displayFormat:column }}</pre>    
                  <pre *ngSwitchDefault class="ui-cell-content">{{ $any(tableItem)[column.name] | displayFormat:column }}</pre>
                </ng-container>
              </ng-template>
            </ng-template>
          </ng-container>
        </p-cellEditor>
      </ng-container>
  </td>

  <td class="table-col-actions w-10rem vertical-align-top">
    <span class="ui-cell-content">
      <ng-container *ngIf="!readOnly">
        <div class="flex align-items-center justify-content-end gap-2">
          <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(tableMeta, item)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(tableMeta, item, rowIndex)" [disabled]="formInvalid" class="p-button-rounded p-button-text p-button-success"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(tableMeta, item, rowIndex)" class="p-button-rounded p-button-text p-button-danger"></button>
          <button pButton pRipple type="button" pCancelEditableRow icon="pi pi-trash" (click)="onRowDelete(tableMeta, item, rowIndex)" class="p-button-rounded p-button-text p-button-info"></button>
        </div>
        <ntap-dynamic #rowActionBar [compId]="DEFAULT_ACTION_BAR_COMP_ID" [hidden]="true"></ntap-dynamic>
      </ng-container>
      <ng-container *ngIf="readOnly">
        <ntap-dynamic #rowActionBar [compId]="DEFAULT_ACTION_BAR_COMP_ID" [hidden]="true"></ntap-dynamic>
      </ng-container>
    </span>
  </td>
</ng-container>
